module.exports = "<div class=\"Modal\" sa-fastclick touch=\"modal\">\n  <div class=\"Modal-wrapper\">\n    <div class=\"Modal-window\">\n      <div class=\"Modal-header\">\n        <h1 class=\"Modal-title\">{{title}}</h1>\n        <a ng-if=\"!closeOff\" class=\"Modal-close\" ng-click=\"!modalOptions.closeOnBackgroundClick && dismiss()\"><i class=\"Icon Icon-close\"></i></a>\n      </div>\n      <div class=\"Modal-body\" ng-transclude sa-on-click-outside=\"modalOptions.closeOnBackgroundClick && dismiss()\"></div>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/directives/modal.html
// module id = 481
// module chunks = 24